import * as Raven from 'raven-js';
import * as React from 'react';
import { Subtract } from 'utility-types';
import { ErrorMessage } from '../components/ErrorMessage';
import { resetAfterError } from '../store/actions';

const MISSING_ERROR = 'Error was swallowed during propagation.';

interface IInjectedProps {
  onReset: () => void;
}

export const withErrorBoundary = <WrappedProps extends IInjectedProps>(
  WrappedComponent: React.ComponentType<IInjectedProps>,
) => {
  type HocProps = Subtract<WrappedProps, IInjectedProps> & {
    // here you can extend hoc props
  };
  interface IHocState {
    readonly error: Error | null | undefined;
  }

  return class WithErrorBoundary extends React.Component<HocProps, IHocState> {
    public displayName = `withErrorBoundary(${WrappedComponent.name})`;

    public state: IHocState = {
      error: undefined,
    };

    public componentDidCatch(error: Error | null, errorInfo: object) {
      this.setState({ error: error || new Error(MISSING_ERROR) });
      this.logErrorToCloud(error, errorInfo);
    }

    public logErrorToCloud = (error: Error | null, errorInfo: object) => {
      if (error) {
        Raven.captureException(error, { extra: errorInfo });

        resetAfterError();
      }
    };

    public render() {
      const { children, ...restProps } = this.props as {
        children: React.ReactNode;
      };
      const { error } = this.state;

      if (error) {
        return <WrappedComponent {...restProps} onReset={this.handleReset} />;
      }

      return children;
    }

    private handleReset = () => window.location.reload();
  };
};

const ErrorBoundary = withErrorBoundary(ErrorMessage);

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/hoc/withErrorBoundary.tsx